import _slicedToArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from 'react';
import { WalletDialogContext } from './useWalletDialog';
import { WalletDialog } from './WalletDialog';
export var WalletDialogProvider = function WalletDialogProvider(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return React.createElement(WalletDialogContext.Provider, {
    value: {
      open: open,
      setOpen: setOpen
    }
  }, children, React.createElement(WalletDialog, Object.assign({}, props)));
};